/**
 * hellopanda-sticky
 */

const HELLOPANDA_STICKY = {
  init: function() {

    let Sticky;
    try {
      Sticky = require('sticky-js');
    } catch (error) {
      console.warn("Sticky-js module not found, the Sticky-js effect is disabled.");
    }
    
    if (typeof Sticky === 'function') {
      window.hellopanda = window.hellopanda || {} ;
      window.hellopanda.library = window.hellopanda.library || {} ;
      window.hellopanda.library.sticky = new Sticky('.wp-block-hellopanda-sticky-item-block');
    }

  }
};
HELLOPANDA_STICKY.init();